import React from "react"

/**
 *
 * @param {Array} engravings Engravings object
 * @param {Object} choices
 *
 * @returns {Array} list of engravings ids that have errors
 */
export const validateEngravings = (engravings, choices) => {
  let errors = []
  if (engravings && engravings.length) {
    engravings.map(engraving => {
      if (
        choices[engraving.pref] &&
        choices[engraving.pref].value &&
        (choices[engraving.pref].value.length < engraving.min_chars ||
          choices[engraving.pref].value.length > engraving.max_chars)
      ) {
        errors.push(engraving.pref)
      }
    })
  }
  return errors
}

/**
 * Check if product Engravings have errors
 *
 * @param {Array} engravings
 * @param {Object} choices
 * @returns {Boolean}
 */
export const engravingsValid = (engravings, choices) => {
  return validateEngravings(engravings, choices).length == 0
}

/**
 * simple use validation hook
 * @param {Array} engravings
 * @param {Object} choices
 */
export function useEngravingsValidation(engravings, choices) {
  const [isValid, setState] = React.useState(false)
  const [errors, setErrors] = React.useState([])
  React.useEffect(() => {
    const validationErrors = validateEngravings(engravings, choices)
    setErrors(validationErrors)
    setState(Object.keys(validationErrors).length == 0)
    return () => {}
  }, [engravings, choices])

  return [isValid, errors]
}
